import styles from './styles.module.css';
import Button from '@/components/common/Button';
import PlateInput from './PlateInput';
import MainIcons from '@/icons/main';
import { useEffect, useState } from 'react';
import { Car } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'use-intl';
import { vehicle_fine_path } from '@/api/global';

export function PlateLookup({ onSearch }: { onSearch?: (x?: Car) => void }) {
  const { activeCar } = useLayoutContext();
  const [inputValue, setInputValue] = useState<Car | undefined>(activeCar);
  const t = useTranslations('HomePage');

  useEffect(() => {
    setInputValue(activeCar);
  }, [activeCar]);

  return (
    <div className={styles.wrap}>
      <PlateInput
        title={t('enterPlateNum')}
        titleIcon={<MainIcons.notifIcon fill="var(--accent-light)" />}
        callBackInputChange={(x?: Car) => setInputValue(x)}
        // noMaxWidth={true}
      />

      <div className={styles.actions}>
        <Button
          className={`btn btn-primary ${styles.search}`}
          onClick={() => onSearch && onSearch(inputValue)}
          wrapperStyle={styles.buttonWrapperSearch}
          type="link"
          href={vehicle_fine_path}
        >
          <MainIcons.flashIcon fill="currentColor" />
          {t('fineLookup')}
        </Button>
        {/* <Button
          href="#assistant"
          className={`btn btn-ghost ${styles.chat}`}
          wrapperStyle={styles.buttonWrapper}
        >
          <MainIcons.ChatIcon />
          {t('chatWithassistant')}
        </Button> */}
      </div>
    </div>
  );
}
